import React from 'react';
import Stack from 'react-bootstrap/Stack';
import LaunchSelectionHeader from './launch-selection-header';
import LaunchSelectionContent from './launch-selection-content';

function LaunchSelection({ selectionMade }) {
  return (
    <Stack gap={1} className="h-100">
      <LaunchSelectionHeader />
      <LaunchSelectionContent selectionMade={selectionMade} />
    </Stack>
  );
}

export default LaunchSelection;
